export var ColorParamNames = {
    BACKGROUND: 'thankYou_background',
    WIDGET_BACKGROUND: 'thankYou_widget_background',
    BORDER_COLOR: 'thankYou_borderColor',
    DIVIDERS_COLOR: 'thankYou_dividersColor',
    TITLES_COLOR: 'thankYou_titleColor',
    PAGE_TEXT_COLOR: 'thankYou_textColor',
    INFO_TEXT_COLOR: 'thankYou_infoTextColor',
    LINKS_TEXT_COLOR: 'thankYou_linksTextColor',
};
export var NumberParamNames = {
    BORDER_WIDTH: 'thankYou_borderWidth',
};
export var FontParamNames = {
    TITLES_FONT: 'thankYou_titleFontStyle',
    PAGE_TEXT_FONT: 'thankYou_textFontStyle',
    INFO_TEXT_FONT: 'thankYou_infoTextFontStyle',
    LINKS_TEXT_FONT: 'thankYou_linksTextFontStyle',
};
export var BooleanParamNames = {
    ORDER_NUMBER_SELECTION: 'THANK_YOU_PAGE_ORDER_NUMBER_SELECTION',
    IMAGE_SELECTION: 'THANK_YOU_PAGE_IMAGE_SELECTION',
    CONTINUE_BROWSING_LINK_SELECTION: 'THANK_YOU_PAGE_CONTINUE_BROWSING_LINK_SELECTION',
};
export var TextParamNames = {
    TITLE: 'THANK_YOU_PAGE_TITLE',
    SUBTITLE: 'THANK_YOU_PAGE_SUBTITLE',
    ORDER_NUMBER_LABEL: 'THANK_YOU_PAGE_ORDER_NUMBER_LABEL',
    TOTAL_COST_LABEL: 'THANK_YOU_PAGE_TOTAL_COST_LABEL',
    SHIPPING_ADDRESS_LABEL: 'THANK_YOU_PAGE_SHIPPING_ADDRESS_LABEL',
    BILLING_ADDRESS_LABEL: 'THANK_YOU_PAGE_BILLING_ADDRESS_LABEL',
    PAYMENT_METHOD_LABEL: 'THANK_YOU_PAGE_PAYMENT_METHOD_LABEL',
    CONTINUE_SHOPPING_CAPTION: 'THANK_YOU_PAGE_CONTINUE_SHOPPING_LINK_CAPTION',
    CONTINUE_BROWSING_CAPTION: 'THANK_YOU_PAGE_CONTINUE_BROWSING_LINK_CAPTION',
    CONTINUE_SHOPPING_LINK: 'THANK_YOU_PAGE_CONTINUE_SHOPPING_LINK_OBJECT',
    SUBSCRIPTION_TITLE: 'THANK_YOU_PAGE_SUBSCRIPTION_TITLE',
    SUBSCRIPTION_SUBTITLE: 'THANK_YOU_PAGE_SUBSCRIPTION_SUBTITLE',
    SUBSCRIPTION_PLAN: 'THANK_YOU_PAGE_SUBSCRIPTION_PLAN',
};
//# sourceMappingURL=thank-you-page-style-params.js.map